import React from "react";
import { StyledButtonsContainer } from "./CmSheetFooterRight.styled";
import {
  Button,
  ButtonSizes,
  ButtonVariants,
} from "../../../../../../components/core/Button/Button";
import {
  CANCEL_LABEL,
  EDIT_LABEL,
  SAVE_LABEL,
} from "../../../../../../constants/Dictionary";
import { ReactComponent as SaveIcon } from "../../../../../../icons/save.svg";
import { ReactComponent as EditIcon } from "../../../../../../icons/pencil.svg";
import { ReactComponent as CancelIcon } from "../../../../../../icons/close.svg";
import {
  CmSheetStateMachine,
  CollaboratorCmSheet,
} from "../../../../../../types/api/collaborators.type";
import { CmSheetStateEnum } from "../../../../../../constants/AppConstants";
import { ConfirmCmSheetChip } from "../ConfirmCmSheetChip/ConfirmCmSheetChip";

interface CmSheetFooterRightProps {
  showEdit: boolean;
  cmSheetInfo: CollaboratorCmSheet;
  cmSheetStateMachineInfo: CmSheetStateMachine;
  isMyProfile?: boolean;
  disabledEditButton?: boolean;
  form?: string;
  onClick?: () => void;
  edit?: boolean;
  setEdit?: (value: boolean) => void;
}

export const CmSheetFooterRight = ({
  disabledEditButton,
  showEdit,
  form,
  onClick,
  edit = false,
  setEdit,
  cmSheetInfo,
  cmSheetStateMachineInfo,
  isMyProfile,
}: CmSheetFooterRightProps) => {
  const confirmCmSheetButtonIsVisible = () => {
    if (
      isMyProfile &&
      [
        CmSheetStateEnum.DRAFT,
        CmSheetStateEnum.INTERMEDIATE_EVALUATION,
        CmSheetStateEnum.FINAL_FEEDBACK,
        CmSheetStateEnum.FINAL_CALIBRATION,
      ].includes(cmSheetStateMachineInfo.currentState) &&
      !cmSheetStateMachineInfo.isRevisionConfirmed
    ) {
      return true;
    }

    return false;
  };

  if (confirmCmSheetButtonIsVisible()) {
    return (
      <ConfirmCmSheetChip
        cmSheetInfo={cmSheetInfo}
        cmSheetStateMachineInfo={cmSheetStateMachineInfo}
      />
    );
  }

  if (showEdit) {
    return (
      <StyledButtonsContainer>
        {edit && (
          <>
            <Button
              label={CANCEL_LABEL}
              onClick={setEdit ? () => setEdit(false) : undefined}
              icon={<CancelIcon />}
              variant={ButtonVariants.SECONDARY}
              size={ButtonSizes.REGULAR}
            />
            <Button
              label={SAVE_LABEL}
              disabled={disabledEditButton}
              onClick={onClick}
              icon={<SaveIcon />}
              size={ButtonSizes.REGULAR}
              form={form}
              type="submit"
            />
          </>
        )}
        {!edit && (
          <Button
            label={EDIT_LABEL}
            onClick={setEdit ? () => setEdit(true) : undefined}
            icon={<EditIcon />}
            size={ButtonSizes.REGULAR}
          />
        )}
      </StyledButtonsContainer>
    );
  }

  return null;
};
